import React from 'react';
import './style.css';
import { ReactSVG } from 'react-svg';
import { HeroIconsProps } from './types';
import { composeClassName } from '../../../../../utils/util_helpers';

const HeroIcons: React.FC<HeroIconsProps> = ({
  name,
  strokeColor = '#1a1a1a',
  hoverStrokeColor,
  strokeWidth,
  size = 24,
  className,
  type = 'outline',
  ...props
}) => {
  const style = {
    '--icon-color-heroicons': strokeColor,
    ...(hoverStrokeColor && { '--icon-color-heroicons--hover': hoverStrokeColor }),
    ...(strokeWidth && { '--icon-stroke-width': strokeWidth }),
  } as React.CSSProperties;

  return (
    <ReactSVG
      data-testid={name}
      src={require(`@assets/icons/heroicons/${type}/${name}.svg`)}
      className={composeClassName(
        'inline-block align-baseline',
        'icon-heroicons',
        hoverStrokeColor && 'icon-heroicons-hover',
        className && className
      )}
      style={style}
      beforeInjection={(svg) => {
        svg.setAttribute('width', `${size}`);
        svg.setAttribute('height', `${size}`);
      }}
      {...props}
    />
  );
};

export { HeroIcons };
